var ve = Object.defineProperty;
var _e = (n, e, t) => e in n ? ve(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var J = (n, e, t) => (_e(n, typeof e != "symbol" ? e + "" : e, t), t);
import { utils as c, BaseDocument as O, applyMixins as Oe, actions as we } from "document-model/document";
import { z as r } from "./account-snapshot.js";
const Ae = {
  id: "powerhouse/document-drive",
  name: "DocumentDrive",
  extension: "phdd",
  description: "",
  author: {
    name: "Powerhouse Inc",
    website: "https://www.powerhouse.inc/"
  },
  specifications: [
    {
      version: 1,
      changeLog: [],
      state: {
        global: {
          schema: `type FolderNode {
    id: String!
    name: String!
    kind: String!
    parentFolder: String
}

type SynchronizationUnit {
    syncId: ID!
    scope: String!
    branch: String!
}

type FileNode {
    id: String!
    name: String!
    kind: String!
    documentType: String!
    parentFolder: String
    synchronizationUnits: [SynchronizationUnit!]!
}

union Node = FolderNode | FileNode

type DocumentDriveState {
    id: ID!
    name: String!
    nodes: [Node!]!
    icon: String
    slug: String
}`,
          initialValue: '"{\\"id\\":\\"\\",\\"name\\":\\"\\",\\"nodes\\":[],\\"icon\\":null,\\"slug\\":null}"',
          examples: []
        },
        local: {
          schema: `type ListenerFilter {
    documentType: [String!]!
    documentId: [ID!]
    scope: [String!]
    branch: [String!]
}

enum TransmitterType {
    Internal,
    SwitchboardPush,
    PullResponder,
    SecureConnect, 
    MatrixConnect,
    RESTWebhook
}

type ListenerCallInfo {
    transmitterType: TransmitterType
    name: String
    data: String
}

type Listener {
    listenerId: ID!
    label: String
    block: Boolean!
    system: Boolean!
    filter: ListenerFilter!
    callInfo: ListenerCallInfo
}

enum TriggerType {
    PullResponder
}

type PullResponderTriggerData {
    listenerId: ID!
    url: String!
    interval: String!
}

union TriggerData = PullResponderTriggerData

type Trigger {
    id: ID!
    type: TriggerType!
    data: TriggerData
}

type DocumentDriveLocalState{
    sharingType: String
    listeners: [Listener!]!
    triggers: [Trigger!]!
    availableOffline: Boolean!
}`,
          initialValue: '"{ \\"listeners\\": [], \\"triggers\\": [], \\"sharingType\\": \\"private\\", \\"availableOffline\\": false}"',
          examples: []
        }
      },
      modules: [
        {
          id: "GRzuvv78tBvmB6ciitokLfonNHA=",
          name: "Node",
          description: "",
          operations: [
            {
              id: "7xiTdxonc9yEASR8sfV/KnbSV10=",
              name: "ADD_FILE",
              description: "",
              schema: `input AddFileInput {
    id: ID!
    name: String!
    documentType: String!
    parentFolder: ID
    synchronizationUnits: [SynchronizationUnit!]!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "4lzNMMKKdIAtEU6i12xLgi9hp+U=",
              name: "ADD_FOLDER",
              description: "",
              schema: `input AddFolderInput {
    id: ID!
    name: String!
    parentFolder: ID
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "53jH2/3TWTTcgCJiv2C+BmuC6i0=",
              name: "DELETE_NODE",
              description: "",
              schema: `input DeleteNodeInput {
    id: ID!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "pNn+Y1/HVq/GNMk7t0u3g3gtMLE=",
              name: "UPDATE_FILE",
              description: "",
              schema: `input UpdateFileInput {
    id: ID!
    parentFolder: ID
    name: String
    documentType: String
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "P0x1M8Mnt+Q/+9nggkwgVbfybsc=",
              name: "UPDATE_NODE",
              description: "",
              schema: `input UpdateNodeInput {
    id: ID!
    parentFolder: ID
    name: String
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "vnQ7OB5b3wGLgjhbgJqAIpA+JLE=",
              name: "COPY_NODE",
              description: "",
              schema: `input CopyNodeInput {
    srcId: ID!
    targetId: ID!
    targetName: String
    targetParentFolder: ID
    synchronizationUnits: [SynchronizationUnit!]
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "VNyiD/sNGzk6k9A1Qe7s8dmrJxA=",
              name: "MOVE_NODE",
              description: "",
              schema: `input MoveNodeInput {
    srcFolder: ID!
    targetParentFolder: ID
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            }
          ]
        },
        {
          id: "0dHwHlxOM9x0vMZ+gLnKxf2qTEo=",
          name: "Drive",
          description: "",
          operations: [
            {
              id: "qGCiPGpTt/cyz3HzyrBn92z1dsU=",
              name: "SET_DRIVE_NAME",
              description: "",
              schema: `input SetDriveNameInput {
    name: String!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "qGCiPGpTt/cyz3HzyrBn92z30dsU=",
              name: "SET_DRIVE_ICON",
              description: "",
              schema: `input SetDriveIconInput {
    icon: String!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "qGCiPGpTt/cyz3HzyrBn92z2dsU=",
              name: "SET_SHARING_TYPE",
              description: "",
              schema: `input SetSharingTypeInput {
    type: String!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "local"
            },
            {
              id: "qGCiPGpTt/cyz3HzyrBn92z3dsU=",
              name: "SET_AVAILABLE_OFFLINE",
              description: "",
              schema: `input SetAvailableOfflineInput {
    availableOffline: Boolean!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "local"
            },
            {
              id: "qGCiPGpTt/cyz3HzyrBn92z9dsU=",
              name: "ADD_LISTENER",
              description: "",
              schema: `input AddListenerInput {
    listener: Listener!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "local"
            },
            {
              id: "qGCiPGpTt/cyz3HzyrBn92z10dsU=",
              name: "REMOVE_LISTENER",
              description: "",
              schema: `input RemoveListenerInput {
    listenerId: String!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "local"
            },
            {
              id: "qGCiPGpTt/cyz3HzyrBn92z20dsU=",
              name: "ADD_TRIGGER",
              description: "",
              schema: `input AddTriggerInput {
    trigger: Trigger!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "local"
            },
            {
              id: "qGCiPGpTt/cyz3HzyrBn92z30dsU=",
              name: "REMOVE_TRIGGER",
              description: "",
              schema: `input RemoveTriggerInput {
    triggerId: String!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "local"
            }
          ]
        }
      ]
    }
  ]
}, Q = (n) => n != null, Le = r.any().refine((n) => Q(n)), Z = r.enum(["Internal", "MatrixConnect", "PullResponder", "RESTWebhook", "SecureConnect", "SwitchboardPush"]), X = r.enum(["PullResponder"]);
function w() {
  return r.object({
    document: r.unknown().nullish(),
    documentType: r.string(),
    id: r.string(),
    name: r.string(),
    parentFolder: r.string().nullish(),
    synchronizationUnits: r.array(b())
  });
}
function A() {
  return r.object({
    id: r.string(),
    name: r.string(),
    parentFolder: r.string().nullish()
  });
}
function L() {
  return r.object({
    listener: P()
  });
}
function U() {
  return r.object({
    trigger: $()
  });
}
function z() {
  return r.object({
    srcId: r.string(),
    synchronizationUnits: r.array(b()).nullish(),
    targetId: r.string(),
    targetName: r.string().nullish(),
    targetParentFolder: r.string().nullish()
  });
}
function R() {
  return r.object({
    id: r.string()
  });
}
function Ue() {
  return r.object({
    __typename: r.literal("DocumentDriveLocalState").optional(),
    availableOffline: r.boolean(),
    listeners: r.array(P()),
    sharingType: r.string().nullable(),
    triggers: r.array($())
  });
}
function ze() {
  return r.object({
    __typename: r.literal("DocumentDriveState").optional(),
    icon: r.string().nullable(),
    id: r.string(),
    name: r.string(),
    nodes: r.array(ie()),
    slug: r.string().nullable()
  });
}
function ee() {
  return r.object({
    __typename: r.literal("FileNode").optional(),
    documentType: r.string(),
    id: r.string(),
    kind: r.string(),
    name: r.string(),
    parentFolder: r.string().nullable(),
    synchronizationUnits: r.array(b())
  });
}
function ne() {
  return r.object({
    __typename: r.literal("FolderNode").optional(),
    id: r.string(),
    kind: r.string(),
    name: r.string(),
    parentFolder: r.string().nullable()
  });
}
function P() {
  return r.object({
    __typename: r.literal("Listener").optional(),
    block: r.boolean(),
    callInfo: re().nullable(),
    filter: te(),
    label: r.string().nullable(),
    listenerId: r.string(),
    system: r.boolean()
  });
}
function re() {
  return r.object({
    __typename: r.literal("ListenerCallInfo").optional(),
    data: r.string().nullable(),
    name: r.string().nullable(),
    transmitterType: Z.nullable()
  });
}
function te() {
  return r.object({
    __typename: r.literal("ListenerFilter").optional(),
    branch: r.array(r.string()).nullable(),
    documentId: r.array(r.string()).nullable(),
    documentType: r.array(r.string()),
    scope: r.array(r.string()).nullable()
  });
}
function x() {
  return r.object({
    srcFolder: r.string(),
    targetParentFolder: r.string().nullish()
  });
}
function ie() {
  return r.union([ee(), ne()]);
}
function oe() {
  return r.object({
    __typename: r.literal("PullResponderTriggerData").optional(),
    interval: r.string(),
    listenerId: r.string(),
    url: r.string()
  });
}
function C() {
  return r.object({
    listenerId: r.string()
  });
}
function G() {
  return r.object({
    triggerId: r.string()
  });
}
function j() {
  return r.object({
    availableOffline: r.boolean()
  });
}
function k() {
  return r.object({
    icon: r.string()
  });
}
function M() {
  return r.object({
    name: r.string()
  });
}
function V() {
  return r.object({
    type: r.string()
  });
}
function b() {
  return r.object({
    __typename: r.literal("SynchronizationUnit").optional(),
    branch: r.string(),
    scope: r.string(),
    syncId: r.string()
  });
}
function $() {
  return r.object({
    __typename: r.literal("Trigger").optional(),
    data: ae().nullable(),
    id: r.string(),
    type: X
  });
}
function ae() {
  return oe();
}
function H() {
  return r.object({
    documentType: r.string().nullish(),
    id: r.string(),
    name: r.string().nullish(),
    parentFolder: r.string().nullish()
  });
}
function B() {
  return r.object({
    id: r.string(),
    name: r.string().nullish(),
    parentFolder: r.string().nullish()
  });
}
const nn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddFileInputSchema: w,
  AddFolderInputSchema: A,
  AddListenerInputSchema: L,
  AddTriggerInputSchema: U,
  CopyNodeInputSchema: z,
  DeleteNodeInputSchema: R,
  DocumentDriveLocalStateSchema: Ue,
  DocumentDriveStateSchema: ze,
  FileNodeSchema: ee,
  FolderNodeSchema: ne,
  ListenerCallInfoSchema: re,
  ListenerFilterSchema: te,
  ListenerSchema: P,
  MoveNodeInputSchema: x,
  NodeSchema: ie,
  PullResponderTriggerDataSchema: oe,
  RemoveListenerInputSchema: C,
  RemoveTriggerInputSchema: G,
  SetAvailableOfflineInputSchema: j,
  SetDriveIconInputSchema: k,
  SetDriveNameInputSchema: M,
  SetSharingTypeInputSchema: V,
  SynchronizationUnitSchema: b,
  TransmitterTypeSchema: Z,
  TriggerDataSchema: ae,
  TriggerSchema: $,
  TriggerTypeSchema: X,
  UpdateFileInputSchema: H,
  UpdateNodeInputSchema: B,
  definedNonNullAnySchema: Le,
  isDefinedNonNullAny: Q
}, Symbol.toStringTag, { value: "Module" })), h = {
  addFileOperation(n, e, t) {
    if (n.nodes.find((p) => p.id === e.input.id))
      throw new Error(`Node with id ${e.input.id} already exists!`);
    const i = I({
      nodes: n.nodes,
      srcName: e.input.name,
      targetParentFolder: e.input.parentFolder || null
    }), o = e.input.synchronizationUnits, a = o.find(
      (p) => !!n.nodes.find(
        (d) => m(d) && d.synchronizationUnits.find(
          (u) => u.syncId === p.syncId
        )
      )
    );
    if (a)
      throw new Error(
        `A synchronization unit with Id ${a.syncId} already exists`
      );
    const l = {
      id: e.input.id,
      name: i,
      kind: "file",
      parentFolder: e.input.parentFolder ?? null,
      synchronizationUnits: o,
      documentType: e.input.documentType
    };
    n.nodes.push(l), t == null || t({
      type: "CREATE_CHILD_DOCUMENT",
      input: {
        id: e.input.id,
        documentType: e.input.documentType,
        synchronizationUnits: o,
        document: e.input.document
      }
    });
  },
  addFolderOperation(n, e) {
    if (n.nodes.find((i) => i.id === e.input.id))
      throw new Error(`Node with id ${e.input.id} already exists!`);
    const t = I({
      nodes: n.nodes,
      srcName: e.input.name,
      targetParentFolder: e.input.parentFolder || null
    });
    n.nodes.push({
      ...e.input,
      name: t,
      kind: "folder",
      parentFolder: e.input.parentFolder ?? null
    });
  },
  deleteNodeOperation(n, e, t) {
    const i = n.nodes.find((a) => a.id === e.input.id);
    if (!i)
      throw new Error(`Node with id ${e.input.id} not found`);
    const o = E(i, n.nodes);
    n.nodes = n.nodes.filter(
      (a) => a.id !== e.input.id && !o.find((l) => l.id === a.id)
    ), [i, ...o].filter((a) => m(a)).forEach((a) => {
      t == null || t({
        type: "DELETE_CHILD_DOCUMENT",
        input: {
          id: a.id
        }
      });
    });
  },
  updateFileOperation(n, e) {
    n.nodes = n.nodes.map(
      (t) => t.id === e.input.id ? {
        ...t,
        name: I({
          nodes: n.nodes,
          srcName: e.input.name ?? t.name,
          targetParentFolder: e.input.parentFolder || null
        }),
        documentType: e.input.documentType ?? t.documentType
      } : t
    );
  },
  updateNodeOperation(n, e) {
    n.nodes = n.nodes.map(
      (t) => t.id === e.input.id ? {
        ...t,
        name: I({
          nodes: n.nodes,
          srcName: e.input.name ?? t.name,
          targetParentFolder: e.input.parentFolder || null
        }),
        parentFolder: e.input.parentFolder === null ? null : t.parentFolder
      } : t
    );
  },
  copyNodeOperation(n, e, t) {
    const i = n.nodes.find((d) => d.id === e.input.srcId);
    if (!i)
      throw new Error(`Node with id ${e.input.srcId} not found`);
    if (n.nodes.find(
      (d) => d.id === e.input.targetId
    ))
      throw new Error(
        `Node with id ${e.input.targetId} already exists`
      );
    const a = I({
      nodes: n.nodes,
      srcName: e.input.targetName || i.name,
      targetParentFolder: e.input.targetParentFolder || null
    }), l = {
      ...i,
      name: a,
      id: e.input.targetId,
      parentFolder: e.input.targetParentFolder || null
    }, p = m(l);
    if (p) {
      const d = e.input.synchronizationUnits;
      if (!e.input.synchronizationUnits)
        throw new Error("Synchronization units were not provided");
      const u = d.find(
        (_) => !!n.nodes.find(
          (W) => m(W) && W.synchronizationUnits.find(
            (be) => be.syncId === _.syncId
          )
        )
      );
      if (u)
        throw new Error(
          `A synchronization unit with Id ${u.syncId} already exists`
        );
      l.synchronizationUnits = d;
    }
    n.nodes.push(l), p && (t == null || t({
      type: "COPY_CHILD_DOCUMENT",
      input: {
        id: e.input.srcId,
        newId: e.input.targetId,
        synchronizationUnits: l.synchronizationUnits
      }
    }));
  },
  moveNodeOperation(n, e) {
    if (e.input.srcFolder === e.input.targetParentFolder)
      throw new Error(
        "Circular Reference Error: Attempting to move a node to its current parent folder"
      );
    const t = n.nodes.find(
      (o) => o.id === e.input.srcFolder
    );
    if (!t)
      throw new Error(`Node with id ${e.input.srcFolder} not found`);
    const i = I({
      nodes: n.nodes,
      srcName: t.name,
      targetParentFolder: e.input.targetParentFolder || null
    });
    if (Ee(t) && E(t, n.nodes).find(
      (a) => a.id === e.input.targetParentFolder
    ))
      throw new Error(
        "Circular Reference Error: Cannot move a folder to one of its descendants"
      );
    n.nodes = n.nodes.map((o) => o.id === e.input.srcFolder ? {
      ...o,
      name: i,
      parentFolder: e.input.targetParentFolder || null
    } : o);
  }
}, g = {
  setDriveNameOperation(n, e, t) {
    n.name = e.input.name;
  },
  setDriveIconOperation(n, e, t) {
    n.icon = e.input.icon;
  },
  setSharingTypeOperation(n, e, t) {
    n.sharingType = e.input.type;
  },
  setAvailableOfflineOperation(n, e, t) {
    n.availableOffline = e.input.availableOffline;
  },
  addListenerOperation(n, e, t) {
    if (n.listeners.find(
      (i) => i.listenerId === e.input.listener.listenerId
    ))
      throw new Error(
        `A listener with Id: ${e.input.listener.listenerId} already exists`
      );
    n.listeners.push(e.input.listener);
  },
  removeListenerOperation(n, e, t) {
    n.listeners = n.listeners.filter(
      (i) => i.listenerId === e.input.listenerId
    );
  },
  addTriggerOperation(n, e, t) {
    if (n.triggers.find(
      (i) => i.id === e.input.trigger.id
    ))
      throw new Error(
        `A trigger with Id: ${e.input.trigger.id} already exists`
      );
    n.triggers.push(e.input.trigger);
  },
  removeTriggerOperation(n, e, t) {
    n.triggers = n.triggers.filter(
      (i) => i.id !== e.input.triggerId
    );
  }
}, Re = (n, e, t) => {
  if (c.isBaseAction(e))
    return n;
  switch (e.type) {
    case "ADD_FILE":
      w().parse(e.input), h.addFileOperation(n[e.scope], e, t);
      break;
    case "ADD_FOLDER":
      A().parse(e.input), h.addFolderOperation(n[e.scope], e, t);
      break;
    case "DELETE_NODE":
      R().parse(e.input), h.deleteNodeOperation(n[e.scope], e, t);
      break;
    case "UPDATE_FILE":
      H().parse(e.input), h.updateFileOperation(n[e.scope], e, t);
      break;
    case "UPDATE_NODE":
      B().parse(e.input), h.updateNodeOperation(n[e.scope], e, t);
      break;
    case "COPY_NODE":
      z().parse(e.input), h.copyNodeOperation(n[e.scope], e, t);
      break;
    case "MOVE_NODE":
      x().parse(e.input), h.moveNodeOperation(n[e.scope], e, t);
      break;
    case "SET_DRIVE_NAME":
      M().parse(e.input), g.setDriveNameOperation(n[e.scope], e, t);
      break;
    case "SET_DRIVE_ICON":
      k().parse(e.input), g.setDriveIconOperation(n[e.scope], e, t);
      break;
    case "SET_SHARING_TYPE":
      V().parse(e.input), g.setSharingTypeOperation(n[e.scope], e, t);
      break;
    case "SET_AVAILABLE_OFFLINE":
      j().parse(e.input), g.setAvailableOfflineOperation(n[e.scope], e, t);
      break;
    case "ADD_LISTENER":
      L().parse(e.input), g.addListenerOperation(n[e.scope], e, t);
      break;
    case "REMOVE_LISTENER":
      C().parse(e.input), g.removeListenerOperation(n[e.scope], e, t);
      break;
    case "ADD_TRIGGER":
      U().parse(e.input), g.addTriggerOperation(n[e.scope], e, t);
      break;
    case "REMOVE_TRIGGER":
      G().parse(e.input), g.removeTriggerOperation(n[e.scope], e, t);
      break;
    default:
      return n;
  }
}, T = c.createReducer(Re), Pe = { id: "", name: "", nodes: [], icon: null, slug: null }, xe = { listeners: [], triggers: [], sharingType: "private", availableOffline: !1 }, S = {
  fileExtension: "phdd",
  createState(n) {
    return { global: { ...Pe, ...n == null ? void 0 : n.global }, local: { ...xe, ...n == null ? void 0 : n.local } };
  },
  createExtendedState(n) {
    return c.createExtendedState(
      { ...n, documentType: "powerhouse/document-drive" },
      S.createState
    );
  },
  createDocument(n) {
    return c.createDocument(
      S.createExtendedState(n),
      S.createState
    );
  },
  saveToFile(n, e, t) {
    return c.saveToFile(n, e, "phdd", t);
  },
  saveToFileHandle(n, e) {
    return c.saveToFileHandle(n, e);
  },
  loadFromFile(n) {
    return c.loadFromFile(n, T);
  },
  loadFromInput(n) {
    return c.loadFromInput(n, T);
  }
}, { createAction: f } = c, q = (n) => f(
  "ADD_FILE",
  { ...n },
  void 0,
  w,
  "global"
), de = (n) => f(
  "ADD_FOLDER",
  { ...n },
  void 0,
  A,
  "global"
), se = (n) => f(
  "DELETE_NODE",
  { ...n },
  void 0,
  R,
  "global"
), le = (n) => f(
  "UPDATE_FILE",
  { ...n },
  void 0,
  H,
  "global"
), pe = (n) => f(
  "UPDATE_NODE",
  { ...n },
  void 0,
  B,
  "global"
), Y = (n) => f(
  "COPY_NODE",
  { ...n },
  void 0,
  z,
  "global"
), ue = (n) => f(
  "MOVE_NODE",
  { ...n },
  void 0,
  x,
  "global"
);
class Ce extends O {
  addFile(e) {
    return this.dispatch(q(e));
  }
  addFolder(e) {
    return this.dispatch(de(e));
  }
  deleteNode(e) {
    return this.dispatch(se(e));
  }
  updateFile(e) {
    return this.dispatch(le(e));
  }
  updateNode(e) {
    return this.dispatch(pe(e));
  }
  copyNode(e) {
    return this.dispatch(Y(e));
  }
  moveNode(e) {
    return this.dispatch(ue(e));
  }
}
const { createAction: y } = c, ce = (n) => y(
  "SET_DRIVE_NAME",
  { ...n },
  void 0,
  M,
  "global"
), ge = (n) => y(
  "SET_DRIVE_ICON",
  { ...n },
  void 0,
  k,
  "global"
), me = (n) => y(
  "SET_SHARING_TYPE",
  { ...n },
  void 0,
  V,
  "local"
), ye = (n) => y(
  "SET_AVAILABLE_OFFLINE",
  { ...n },
  void 0,
  j,
  "local"
), he = (n) => y(
  "ADD_LISTENER",
  { ...n },
  void 0,
  L,
  "local"
), Ie = (n) => y(
  "REMOVE_LISTENER",
  { ...n },
  void 0,
  C,
  "local"
), fe = (n) => y(
  "ADD_TRIGGER",
  { ...n },
  void 0,
  U,
  "local"
), Se = (n) => y(
  "REMOVE_TRIGGER",
  { ...n },
  void 0,
  G,
  "local"
);
class Ge extends O {
  setDriveName(e) {
    return this.dispatch(ce(e));
  }
  setDriveIcon(e) {
    return this.dispatch(ge(e));
  }
  setSharingType(e) {
    return this.dispatch(me(e));
  }
  setAvailableOffline(e) {
    return this.dispatch(ye(e));
  }
  addListener(e) {
    return this.dispatch(he(e));
  }
  removeListener(e) {
    return this.dispatch(Ie(e));
  }
  addTrigger(e) {
    return this.dispatch(fe(e));
  }
  removeTrigger(e) {
    return this.dispatch(Se(e));
  }
}
const F = class F extends O {
  constructor(e, t) {
    super(T, S.createDocument(e), t);
  }
  saveToFile(e, t) {
    return super.saveToFile(e, F.fileExtension, t);
  }
  loadFromFile(e) {
    return super.loadFromFile(e);
  }
  static async fromFile(e) {
    const t = new this();
    return await t.loadFromFile(e), t;
  }
};
J(F, "fileExtension", "phdd");
let N = F;
Oe(N, [
  Ce,
  Ge
]);
const je = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addFile: q,
  addFolder: de,
  addListener: he,
  addTrigger: fe,
  copyNode: Y,
  deleteNode: se,
  moveNode: ue,
  removeListener: Ie,
  removeTrigger: Se,
  setAvailableOffline: ye,
  setDriveIcon: ge,
  setDriveName: ce,
  setSharingType: me,
  updateFile: le,
  updateNode: pe
}, Symbol.toStringTag, { value: "Module" }));
let D;
const ke = new Uint8Array(16);
function Me() {
  if (!D && (D = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !D))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return D(ke);
}
const s = [];
for (let n = 0; n < 256; ++n)
  s.push((n + 256).toString(16).slice(1));
function Ve(n, e = 0) {
  return s[n[e + 0]] + s[n[e + 1]] + s[n[e + 2]] + s[n[e + 3]] + "-" + s[n[e + 4]] + s[n[e + 5]] + "-" + s[n[e + 6]] + s[n[e + 7]] + "-" + s[n[e + 8]] + s[n[e + 9]] + "-" + s[n[e + 10]] + s[n[e + 11]] + s[n[e + 12]] + s[n[e + 13]] + s[n[e + 14]] + s[n[e + 15]];
}
const $e = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), K = {
  randomUUID: $e
};
function He(n, e, t) {
  if (K.randomUUID && !e && !n)
    return K.randomUUID();
  n = n || {};
  const i = n.random || (n.rng || Me)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, e) {
    t = t || 0;
    for (let o = 0; o < 16; ++o)
      e[t + o] = i[o];
    return e;
  }
  return Ve(i);
}
function m(n) {
  return n.kind === "file";
}
function Ee(n) {
  return n.kind === "folder";
}
function De(n, e) {
  if (n.parentFolder) {
    const t = e.find(
      (i) => i.id === n.parentFolder
    );
    if (!t)
      throw new Error(
        `Parent node with id ${n.parentFolder} not found`
      );
    return [t, ...De(t, e)];
  } else
    return [];
}
function E(n, e) {
  const t = e.filter((o) => o.parentFolder === n.id), i = t.map((o) => E(o, e));
  return [...t, ...i.flat()];
}
function Be(n, e, t) {
  const i = t.find((d) => d.id === n.srcId);
  if (!i)
    throw new Error(`Node with id ${n.srcId} not found`);
  const o = [
    {
      ...i,
      name: n.targetName || i.name,
      parentFolder: n.targetParentFolder || null
    },
    ...E(i, t)
  ], a = {};
  n.targetParentFolder && (a[n.targetParentFolder] = n.targetParentFolder);
  const l = (d) => {
    let u = a[d];
    if (!u) {
      const _ = d;
      u = e(d), a[_] = u;
    }
    return u;
  };
  return o.map((d) => ({
    srcId: d.id,
    targetId: l(d.id),
    targetName: d.name,
    targetParentFolder: d.parentFolder ? l(d.parentFolder) : null,
    synchronizationUnits: m(d) ? d.synchronizationUnits.map((u) => ({
      ...u,
      syncId: v(t)
    })) : void 0
  }));
}
function v(n) {
  let e = "";
  for (; !e || n.find(
    (t) => m(t) && t.synchronizationUnits.find((i) => i.syncId === e)
  ); )
    e = He();
  return e;
}
function Te(n, e, t = "main") {
  return e.map((i) => ({
    scope: i,
    branch: t,
    syncId: v(n.nodes)
  }));
}
function qe(n, e, t) {
  return q({
    ...e,
    synchronizationUnits: Te(n, t)
  });
}
function Ye(n, e) {
  const t = n.nodes.find((o) => o.id === e.srcId);
  if (!t)
    throw new Error(`Node with id ${e.srcId} not found`);
  let i;
  return m(t) && (i = t.synchronizationUnits.map(
    (o) => ({
      ...o,
      syncId: v(n.nodes)
    })
  )), Y({
    ...e,
    synchronizationUnits: i
  });
}
function Ne(n, e) {
  let t = 0;
  const i = new RegExp(
    `^${Fe(e)} \\(copy\\)(?: (\\d+))?$`
  );
  for (const o of n) {
    const a = o.match(i);
    if (a) {
      const l = a[1] ? parseInt(a[1], 10) : 1;
      l > t && (t = l);
    }
  }
  return t + 1;
}
function Fe(n) {
  return n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function I(n) {
  const { nodes: e, targetParentFolder: t, srcName: i } = n, o = e.filter(
    (p) => t === "" ? p.parentFolder === null : p.parentFolder === t
  ).map((p) => p.name);
  return o.includes(i) ? `${i} (copy) ${Ne(o, i)}` : i;
}
const We = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  escapeRegExp: Fe,
  generateAddNodeAction: qe,
  generateCopyNodeAction: Ye,
  generateNodesCopy: Be,
  generateSynchronizationUnitId: v,
  generateSynchronizationUnits: Te,
  getAncestors: De,
  getDescendants: E,
  getNextCopyNumber: Ne,
  handleTargetNameCollisions: I,
  isFileNode: m,
  isFolderNode: Ee
}, Symbol.toStringTag, { value: "Module" })), Je = N, Ke = { ...S, ...We }, Qe = { ...we, ...je }, rn = {
  Document: Je,
  reducer: T,
  actions: Qe,
  utils: Ke,
  documentModel: Ae
};
export {
  N as D,
  Je as a,
  Qe as b,
  Ee as c,
  Ae as d,
  E as e,
  Be as f,
  De as g,
  v as h,
  m as i,
  Te as j,
  qe as k,
  Ye as l,
  rn as m,
  Ne as n,
  Fe as o,
  I as p,
  T as r,
  Ke as u,
  He as v,
  nn as z
};
